import { render } from "./RfTexto.vue?vue&type=template&id=7544d70d"
import script from "./RfTexto.vue?vue&type=script&lang=js"
export * from "./RfTexto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__